import { getBackendUrl } from "../../utils";
import IconComponent from "@CubeComponents/icons";
import { ButtonComponentProps } from "../interface";
import { BUTTON_TYPES, COLORS, CONSTANTS } from "./globalVariable";
import { SignTypeValues } from ".";
import { t } from "@i18n";

export const get_button_component_custom_style = (props: ButtonComponentProps) => {
  const {
    gradientColor1,
    gradientColor2,
    fontWeight,
    borderRadius,
    gradientTextColor2,
    gradientTextColor1,
    borderColor,
    borderWidth,
    borderType,
    padding,
    bgColor,
    btnColor,
    gradientBorderColor1,
    gradientBorderColor2,
    disabled,
    buttonType,
    height,
    width,
    textAlign,
  } = props;

  let backGround = CONSTANTS.BLANK;

  if (gradientColor1 && gradientColor2) {
    backGround = `linear-gradient(100.44deg, ${gradientColor1} 0%, ${gradientColor2} 110.4%)`;
  } else if (bgColor) {
    backGround = bgColor;
  } else if (gradientTextColor1 && gradientTextColor2) {
    backGround = `-webkit-linear-gradient(${gradientTextColor1}, ${gradientTextColor2})`;
  }
  return {
    ...(!disabled &&
      !buttonType && {
        fontWeight: fontWeight,
        textAlign: textAlign,
        height: height,
        width: width,
        borderRadius: `${borderRadius ?? 0}`,
        background: backGround,
        ...(gradientTextColor1 &&
          gradientTextColor2 && {
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }),
        color: `${btnColor ?? CONSTANTS.BLANK}`,
        borderColor: `${borderColor ?? CONSTANTS.BLANK}`,
        borderWidth: `${borderWidth ?? "0px"}`,
        borderStyle: `${borderType ?? CONSTANTS.NONE}`,
        padding: `${padding ? padding : CONSTANTS.NONE}`,
        ...(gradientBorderColor1 &&
          gradientBorderColor2 && {
            borderStyle: borderType,
            borderWidth: borderWidth,
            borderImage: `linear-gradient(45deg, ${gradientBorderColor1}, ${gradientBorderColor2}) 1`,
          }),
      }),
    ...(disabled &&
      !buttonType && {
        background: "#ECF3FE",
        color: "rgba(25, 32, 72, 0.5)",
        cursor: "not-allowed",
      }),
  };
};

export const btn_Focus_common = () => {
  return { outline: "none" };
};

export const getButtonCommonCss = (isInfo: boolean) => {
  return {
    borderRadius: isInfo ? "25px" : "5px !important",
    border: `${CONSTANTS.NONE} !important`,
  };
};

export const get_normal_gradient_btn = (isInfo: boolean = false) => {
  return {
    background: `linear-gradient(100.44deg, var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)`,
    ...getButtonCommonCss(isInfo),
    color: `var(--surface-white) !important`,
    marginInlineStart: "0 !important",
    "&:hover": {
      background: `linear-gradient(100.44deg, var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)`,
      border: CONSTANTS.NONE,
      color: `var(--surface-white)`,
      boxShadow: "2px 2px 4px 0 var(--button-hover-shadow)",
    },
    "&:focus": {
      color: `var(--surface-white)`,
      ...btn_Focus_common(),
    },
    "&:active": {
      background: `linear-gradient(100.44deg, var(--primary-gradient-color2) 0%, var(--primary-gradient-color2) 110.4%)`,
    },
    "&:disabled": {
      background: `var(--surface-neutral) !important`,
      color: `var(--disabled-text-gray) !important`,
      cursor: "not-allowed",
    },
  };
};

export const get_normal_background_btn = (isInfo = false) => {
  return {
    background: `var(--button-light)`,
    borderRadius: isInfo ? "20px" : "0.3125rem",
    border: CONSTANTS.NONE,
    color: `var(--primary-text)`,
    "&:focus": {
      ...btn_Focus_common(),
      background: `var(--button-light)`,
    },
    "&:hover": {
      background: `var(--button-light)`,
      border: CONSTANTS.NONE,
      color: `var(--primary-text)`,
      boxShadow: "2px 2px 4px 0 var(--button-hover-shadow)",
    },
    "&:active": {
      background: `var(--light-blue)`,
    },
    "&:disabled": {
      background: `var(--button-light)`,
      color: `var(--disabled-text-gray)`,
      cursor: "not-allowed",
    },
  };
};

export const get_info_background_btn = () => {
  return {
    background: `var(--button-light)`,
    borderRadius: "1.25rem",
    border: CONSTANTS.NONE,
    color: `var(--primary-text)`,
    "&:focus": {
      ...btn_Focus_common(),
      background: `var(--primary-blue)`,
      color: `var(--primary-text)`,
    },
    "&:hover": {
      background: `var(--button-light)`,
      color: `var(--primary-text)`,
      boxShadow: "2px 2px 4px 0 var(--button-hover-shadow)",
    },
    "&:active": {
      background: `var(--primary-blue)`,
      color: `var(--primary-text)`,
    },
    "&:disabled": {
      background: `var(--button-light)`,
      color: `var(--disabled-text-gray)`,
      cursor: "not-allowed",
    },
  };
};

export const get_normal_border_btn = () => {
  return {
    overflow: "unset",
    position: "relative",
    background: "transparent !important",
    zIndex: "1",
    color: "var(--primary-text)",
    border: "none",
    "&:before": {
      position: "absolute",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
      background: "var(--surface-white)",
      content: '""',
      zIndex: "-1",
      borderRadius: "0.25rem",
    },
    "&:hover:before, &:focus:before": {
      background:
        "linear-gradient(100.44deg, var(--primary-gradient-color1) 0%,  var(--primary-gradient-color2) 110.4%)",
    },
    "&:after": {
      position: "absolute",
      top: "-1px",
      bottom: "-1px",
      left: "-1px",
      right: "-1px",
      background:
        "linear-gradient(100.44deg, var(--primary-gradient-color1) 0%,  var(--primary-gradient-color2) 110.4%)",
      content: '""',
      zIndex: "-2",
      borderRadius: "0.3125rem",
    },
    marginInlineStart: "0 !important",
    "&:hover, &:focus": {
      color: `var(--surface-white)`,
    },
    "&:hover": {
      boxShadow: "2px 2px 4px 0 var(--button-hover-shadow)",
    },
    "&:focus": {
      ...btn_Focus_common(),
      color: `var(--surface-white)`,
    },
    "&:disabled": {
      border: `2px var(--border-solid) var(--disabled-border) !important`,
      background: "var(--surface-white)",
      WebkitBackgroundClip: "var(--padding-box) !important",
      WebkitTextFillColor: `var(--disabled-text-gray) !important`,
      borderRadius: "5px !important",
      cursor: "var(--not-allowed) !important",
      "&:before": {
        display: "none",
      },
      "&:after": {
        display: "none",
      },
    },
  };
};

export const get_normal_text_btn = () => {
  return {
    border: CONSTANTS.NONE,
    background: "var(--surface-white)",
    borderRadius: "0.3125rem",
    color: "var(--primary-text)",
    "&:hover": {
      background: `var(--info-lighter-blue)`,
      boxShadow: "2px 2px 4px 0 var(--button-hover-shadow)",
    },
    "&:focus": {
      ...btn_Focus_common(),
      background: "var(--surface-white)",
    },
    "&:active": {
      background: `var(--info-light-blue)`,
    },

    "&:disabled": {
      background: `var(--none)`,
      WebkitBackgroundClip: "var(--padding-box)",
      WebkitTextFillColor: `var(--disabled-text-gray)`,
      borderRadius: "0.3125rem",
      cursor: "var(--not-allowed)",
    },
  };
};

export const get_btn_other = (btnType: string) => {
  const bgColor = getOtherBtnColor(btnType);
  return {
    background: bgColor,
    borderRadius: "1rem",
    color: `var(--surface-white)`,
    border: CONSTANTS.NONE,
    "&:hover, &:focus": {
      background: bgColor,
      ...btn_Focus_common(),
      color: `var(--surface-white)`,
    },
    "&:hover": {
      boxShadow: "2px 2px 4px 0 var(--button-hover-shadow)",
    },
    "&:disabled": {
      background: `var(--button-light)`,
      color: `var(--disabled-text-gray)`,
      cursor: "var(--not-allowed)",
    },
  };
};

const getOtherBtnColor = (btnType: string) => {
  if (btnType === BUTTON_TYPES.ACTIVE_BUTTON) {
    return "var(--positive-communication)";
  }
  if (btnType === BUTTON_TYPES.IN_ACTIVE_BUTTON) {
    return "var(--negative-communication)";
  }
  if (btnType === BUTTON_TYPES.IN_PROGRESS_BUTTON) {
    return "var(--warning)";
  }
};

export const getTextboxStyle = (isDisabled: boolean) => {
  return {
    color: "var(--primary-text)",
    height: "2rem",
    ...(isDisabled && {
      background: "var(--button-light)",
      border: "var(--none) !important",
    }),
  };
};

export const getTextboxParentStyle = (widthInPercentage: string, margin?: string) => {
  return {
    borderRadius: "0.125rem",
    width: widthInPercentage,
    border: "var(--none)",
    margin: `${margin} !important`,
  };
};

export const getTextboxClassStyle = () => {
  return {
    outline: CONSTANTS.NONE,
    borderRadius: "2px !important",
    borderColor: "var(--text-light) !important",
    "&:not(.e-disabled):not(.e-input-focus):hover": {
      borderColor: "var(--primary-text) !important",
    },
    "&.e-disabled:hover.e-disabled": {
      borderColor: "var(--transparent)",
    },
    "&.e-input-focus": {
      borderColor: "var(--inner-border) !important",
    },
    "&.e-input-group": {
      border: "1px solid var(--primary-blue) !important",
    },
    "& .e-spin-down,& .e-spin-up,& .e-input-group-icon": {
      background: "var(--transparent) !important",
      color: "var(--primary-text) !important",
    },
    "& .e-spin-down:hover,& .e-spin-up:hover, & .e-input-group-icon:hover": {
      background: "var(--button-light) !important",
      color: "var(--center-border) !important",
    },
    "& .e-spin-down:active,& .e-spin-up:active, & .e-input-group-icon:active": {
      background: "var(--lighter-gray) !important",
      color: "var(--center-border) !important",
    },
    "& textarea": {
      resize: "none !important",
    },
    "&.e-disabled": {
      borderRadius: "2px !important",
      "& .e-input": {
        borderRadius: "2px !important",
      },
      border: "var(--none) !important",
    },
    "& .e-input[disabled]": {
      WebkitTextFillColor: "var(--disabled-text-gray) !important",
    },
  };
};

export const get_splitGradientButton = () => {
  return {
    background: `linear-gradient(100.44deg,  var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)`,
    display: "var(--display-inline-block)",
    borderRadius: "0.125rem",
    // border:'none !important',
    "&.e-dropdown-popup.e-popup.e-control": getDropdownCommonCss(),
    color: `var(--surface-white) !important`,
    "&:hover, &:focus": {
      color: `var(--surface-white)`,
    },
    "& > :nth-child(2)": {
      height: "2rem",
      width: "2rem",
      borderInlineStart: CONSTANTS.NONE,
      background: "none",
      color: `var(--surface-white)`,
      border: CONSTANTS.NONE,
      "& .e-btn-icon.e-icons.e-caret": {
        paddingInlineEnd: "6px !important",
        "&:before": {
          content: "url(/assets/icons/svg/downArrow.svg) !important",
        },
      },
      paddingInlineStart: "10px !important",
      "&.e-btn .e-btn-icon": {
        width: "auto !important",
      },
    },
    "& > :nth-child(2):hover": {
      background: `var(--split-btn-opacity-hover)`,
      color: `var(--surface-white) !important`,
    },
    "& > :nth-child(2):focus": {
      outline: "none",
      background: `var(--split-btn-opacity-hover)`,
    },
    "& > :nth-child(1)": {
      outline: "none",
      borderInlineEnd: CONSTANTS.NONE,
      background: "var(--none)",
      border: CONSTANTS.NONE,
    },
    "&.disabled": {
      background: "var(--button-light) !important",
      cursor: "var(--not-allowed)",
      color: `var(--disabled-text-gray) !important`,
      "& > :nth-child(2)": {
        "& .e-btn-icon.e-icons.e-caret": {
          paddingInlineEnd: "6px !important",
          "&:before": {
            content: "url(/assets/icons/svg/downArrowGray.svg) !important",
          },
        },
      },
    },

    // "& > :nth-child(2) > ::after": {
    //   content: '""',
    //   position: "var(--position-absolute)",
    //   display: "var(--display-block)",
    //   height: "60%",
    //   width: "0.0625rem",
    //   background: `var(--surface-white) !important`,
    //   left: "0",
    //   top: "0.375rem",
    // },
  };
};

export const get_splitBackgroundButton = () => {
  return {
    backgroundColor: `var(--button-light)`,
    display: "var(--display-inline-block)",
    borderRadius: "0.125rem",
    "&.e-dropdown-popup.e-popup.e-control": getDropdownCommonCss(),
    color: `var(--primary-text)`,
    "&:hover, &:focus": {
      color: `var(--primary-gradient-color2)`,
    },
    "& > :nth-child(2)": {
      borderInlineStart: "var(--none)",
      position: "var(--position-relative)",
      background: "var(--none)",
      color: `var(--primary-text)`,
      height: "2rem",
      width: "2rem",
      padding: "2px 3px",
      border: "var(--none)",
    },
    "& > :nth-child(2):hover": {
      background: "var(--light-gray)",
      color: `var(--primary-text)`,
    },
    "& > :nth-child(2):focus": {
      background: "var(--light-blue)",
      color: `var(--primary-text)`,
    },
    "& > :nth-child(1)": {
      borderInlineEnd: "var(--none)",
      background: "var(--none)",
      border: "var(--none)",
    },
    "& > :nth-child(2) > ::after": {
      content: '""',
      position: "var(--position-absolute)",
      display: "var(--display-block)",
      height: "60%",
      width: "var(--none)",
      background: `var(--light-blue) !important`,
      left: "0",
      top: "0.375rem",
    },
  };
};

export const getSplitButtonPositionClassStyle = (gradientColor1: string, gradientColor2: string, bgColor: string) => {
  return {
    background: `${
      gradientColor1 && gradientColor2
        ? `linear-gradient(100.44deg,  ${gradientColor1} 0%, ${gradientColor2} 110.4%)`
        : bgColor
          ? bgColor
          : "var(--none)"
    }`,
    display: "var(--display-inline-block)",
  };
};

export const getSplitButtonCustomClassStyle = (color: string, dropdownArrowBgColor: string, barColor: string) => {
  return {
    "& > :nth-child(2)": {
      color: `${color ? color : COLORS.BLACK}`,
      paddingInlineStart: 10,
      paddingInlineEnd: 10,
      borderInlineStart: CONSTANTS.NONE,
      position: "var(--position-relative)",
      background: dropdownArrowBgColor ? dropdownArrowBgColor : "transparent",
    },

    "& > :nth-child(2) > ::after": {
      content: '""',
      position: "var(--position-absolute)",
      display: "var(--display-block)",
      height: "70%",
      width: "1.5px",
      background: barColor,
      left: "0",
      top: "0.3125rem",
    },
  };
};

export const getDropdownBtnCssClass = (type: string, classes: any) => {
  if (type === BUTTON_TYPES.DROPDOWN_GRADIENT_BUTTON) {
    return `${classes[`${type}`]}`;
  }
  if (type === BUTTON_TYPES.DROPDOWN_BACKGROUND_BUTTON) {
    return `${classes[`${type}`]}`;
  }
  return classes.dropdownBtnCustom;
};

export const getToggleSwitchComponentStyle = (
  dragOffColor: string,
  borderColor: string,
  dragOnColor: string,
  gradientColor1: string,
  gradientColor2: string,
  bgColor: string,
) => {
  return {
    "&.e-switch-wrapper .e-switch-handle ": {
      backgroundColor: dragOffColor ? dragOffColor : "var(--primary-text)",
    },
    "&.e-switch-wrapper .e-switch-inner": {
      border: `1px var(--border-solid) ${borderColor ? borderColor : "var(--primary-text)"}`,
    },
    "&.e-switch-wrapper:not(.e-switch-disabled):hover .e-switch-handle:not(.e-switch-active)": {
      backgroundColor: dragOffColor ? dragOffColor : "var(--primary-text)",
    },
    "&.e-switch-wrapper .e-switch-handle.e-switch-active": {
      backgroundColor: dragOnColor ? dragOnColor : "var(--surface-white) !important",
    },
    "&.e-switch-wrapper .e-switch-inner.e-switch-active,&.e-switch-wrapper:hover .e-switch-inner.e-switch-active .e-switch-on":
      {
        border: "var(--none)",
        background:
          gradientColor1 && gradientColor2
            ? `linear-gradient(100.44deg,  ${gradientColor1} 0%, ${gradientColor2} 110.4%)`
            : bgColor
              ? bgColor
              : `linear-gradient(100.44deg,  var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)`,
      },
    "&.e-switch-wrapper.e-switch-disabled .e-switch-inner .e-switch-off,&.e-switch-wrapper.e-switch-disabled .e-switch-inner .e-switch-on":
      {
        background: "var(--light-blue)",
      },
    "&.e-switch-wrapper.e-switch-disabled .e-switch-inner": {
      border: "var(--none)",
    },
    "&.e-switch-wrapper.e-switch-disabled ": {
      cursor: "var(--not-allowed)",
    },
    ".e-switch-wrapper.e-switch-disabled:hover .e-switch-on": {
      background: "var(--light-blue)",
    },
    "&.e-switch-wrapper.e-switch-disabled .e-switch-handle": {
      background: "var(--surface-white)",
    },
    "& .e-switch-inner": {
      outline: "none !important",
    },
    '&[aria-checked="true"]:active:before': {
      content: '""',
      position: "absolute",
      left: "-3px",
      width: "calc(100% + 6px)",
      top: "-3px",
      height: "calc(100% + 4px)",
      border: "1px var(--border-solid) var(--primary-gradient-color1)",
    },
    '&[aria-checked="false"]:active:before': {
      content: '""',
      position: "absolute",
      left: "-3px",
      width: "calc(100% + 6px)",
      top: "-3px",
      height: "calc(100% + 4px)",
      border: "1px var(--border-solid) var(--primary-text)",
    },
  };
};

export const getCheckBoxComponentStyle = (
  borderColor: string,
  borderColorFocus: string,
  bgColor: string,
  gradientColor1: string,
  gradientColor2: string,
) => {
  return {
    display: "var(--display-inline-block)",
    //TODO: remove below css. this should not come inside the core component
    "& > label": {
      marginInlineEnd: "0.625rem",
      position: "var(--position-relative)",
      minHeight: "1.5rem",
      "&:active:before": {
        border: `2px var(--border-solid) ${borderColorFocus ? borderColorFocus : "var(--primary-gradient-color1)"}`,
        content: '""',
        width: "calc(100% + 7px)",
        height: "calc(100% + 4px)",
        top: "-4px",
        left: "-4px",
        position: "var(--position-absolute)",
      },
    },
    "& > label > input[type='checkbox']": {
      display: CONSTANTS.NONE,
    },

    "& > label > span.e-icons.e-frame": {
      height: "1.25rem",
      width: "1.25rem",
      border: `2px var(--border-solid) ${borderColor ? borderColor : "var(--primary-gradient-color1)"}`,
      borderRadius: "0.125rem",
      "&.e-check": {
        background:
          gradientColor1 && gradientColor2
            ? `linear-gradient(100.44deg,  ${gradientColor1} 0%, ${gradientColor2} 110.4%)`
            : bgColor
              ? bgColor
              : `linear-gradient(100.44deg,  var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)`,
        border: CONSTANTS.NONE,
      },
      "&::before": {
        fontSize: "0.75rem",
        display: "var(--display-flex)",
        alignItems: "var(--align-center)",
        justifyContent: "var(--align-center)",
        height: "100%",
      },
    },
    "& > label:hover > span.e-icons.e-frame:not(.e-check)::before": {
      content: `"\\e935"`,
      color: "var(--natural-gray)",
    },
    "& .e-label": {
      lineHeight: "1rem",
      fontFamily: "Source Sans 3 !important",
    },
  };
};

export const getRadioButtonComponentStyle = (
  borderColor: string,
  borderColorFocus: string,
  bgColor: string,
  gradientColor1: string,
  gradientColor2: string,
) => {
  return {
    display: "var(--display-flex)",
    alignItems: "var(--align-center)",
    "&:active:before": {
      border: `2px var(--border-solid) ${borderColorFocus ? borderColorFocus : "var(--primary-gradient-color1)"}`,
      borderRadius: "0.125rem",
      zIndex: "-10px",
      content: '""',
      width: " calc(100% + 7px)",
      height: " calc(100% + 4px)",
      top: "-4px",
      left: "-4px",
      position: "var(--position-absolute)",
    },
    "& > label": {
      "& .e-label": {
        marginTop: "-2px",
      },
      "&:before": {
        border: "1px var(--border-solid) var(--primary-text)",
        borderRadius: "50%",
        boxSizing: "var(--border-box)",
        content: '""',
        height: "1.25rem",
        left: 0,
        position: "var(--position-absolute)",
        width: "1.25rem",
      },
      "&:after": {
        borderRadius: "50%",
        boxSizing: "var(--border-box)",
        content: '""',
        height: "0.625rem",
        left: "0.3125rem",
        position: "var(--position-absolute)",
        top: "0.3125rem",
        transform: "scale(0)",
        width: "0.625rem",
      },
    },
    "& input:checked ~ label:before": {
      borderColor: borderColor ? borderColor : "var(--primary-gradient-color2)",
    },
    "& input:checked + label:hover:before,& input:checked + label:focus": {
      borderColor: borderColor ? borderColor : "var(--primary-gradient-color2)",
    },
    "& input:checked ~ label:after": {
      background:
        gradientColor1 && gradientColor2
          ? `linear-gradient(100.44deg,  ${gradientColor1} 0%, ${gradientColor2} 110.4%)`
          : bgColor
            ? bgColor
            : `linear-gradient(100.44deg,  var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)`,
      color: "var(--transparent)",
      border: "none",
    },
    "& input:hover ~ label:before": {
      borderColor: "var(--primary-text)",
    },
    "& label .e-label": {
      lineHeight: "1.5rem",
      fontFamily: "Source Sans 3 !important",
    },
  };
};

export const getMultiSelectStyle = () => {
  return {
    border: "1px var(--border-solid) var(--disabled-text-gray) !important",
    borderRadius: "2px !important",
    "&:hover": {
      border: "1px var(--border-solid) var(--primary-text) !important",
    },
    "&:active": {
      border: "1px var(--border-solid) var(--primary-gradient-color1) !important",
    },
    "&.e-multiselect .e-multi-select-wrapper": {
      "& > .e-delim-view,& > .e-chips-close": {
        WebkitTextFillColor: "var(--primary-text)",
        color: "var(--primary-text)",
      },
    },

    "&.e-input-focus": {
      border: "1px var(--border-solid) var(--primary-gradient-color1)!important",
      "& .e-multi-select-wrapper": {
        "& .e-chips-collection": {
          "& .e-chips": {
            background: "var(--button-light) !important",
            "& .e-chipcontent,& .e-chips-close": {
              WebkitTextFillColor: "var(--primary-text)",
              color: "var(--primary-text) !important",
            },
            "&:hover": {
              background: "var(--light-blue) !important",
            },
          },
        },
      },
    },
    "&.e-disabled": {
      border: "var(--none) !important",
      background: "var(--button-light) !important",
      borderRadius: "2px !important",
    },
  };
};

export const getParentProfileStyle = ({ overlapRadius = true, type = CONSTANTS.PROFILE }: any) => {
  return {
    position: "var(--position-relative)",
    alignItems: "center",
    padding: type === "org" ? "9px" : "unset",
    "& .labelName": {
      marginTop: "0",
    },
    "& .editIcon": {
      display: "none",
    },
    "& .profile-root-wrapper": {},
    "& .profile-wrap": {
      display: "inline-block",
      position: "var(--position-relative)",
      overflow: "hidden",
      // borderRadius: overlapRadius ? "100%" : "none",
      height: type === "profile" ? "100px" : "4.6875rem",
      "& img": {
        objectFit: "cover",
      },
      "&:hover": {
        "& .deleteImgContainer": {
          width: type === "org" ? "35px" : "3.125rem",
          backgroundColor: "rgba(255, 255, 255, 0.65)",
          height: type === "org" ? "85px" : "6.25rem",
          borderRadius: overlapRadius ? "0 150px 150px 0" : "none",
          display: "var(--display-flex)",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "0",
          right: "0",
          // left: type === "org" ? "50px" : "unset",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.85)",
          },
        },

        "& .editImgContainer": {
          width: type === "org" ? "40px" : "3.125rem",
          backgroundColor: "rgba(255, 255, 255, 0.65)",
          height: type === "org" ? "85px" : "6.25rem",
          borderRadius: overlapRadius ? "150px 0 0 150px" : "none",
          display: "var(--display-flex)",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "0",
          left: "0",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.85)",
          },
        },

        "& .editIcon": {
          display: "block",
          cursor: "pointer",
        },
      },
    },
  };
};
export const getRichTextEditorStyle = (
  toolbarBgColor: string,
  iconColor: string,
  iconSelectedGradientColor1: string,
  iconSelectedGradientColor2: string,
  iconHoverBgColor: string,
  iconHoverColor: string,
  readonly: any,
  contentHeight: string,
  padding: any,
) => {
  return {
    "&.e-rte-readonly": {
      "& .e-content": {
        color: "var(--primary-text) !important",
        overflowWrap: "break-word",
      },
      "& .e-rte-container": {
        border: "none",
      },
    },
    "& .e-rte-content .e-content": {
      padding: padding ? padding : readonly ? "0px !important" : "1rem",
      height: contentHeight && `${contentHeight}px`,
    },
    "& .e-content": {
      minHeight: `${readonly ? "auto" : "6.25rem"} !important`,
    },
    borderRadius: "0.25rem",
    "& .e-rte-toolbar,& .e-toolbar-wrapper": {
      borderBottom: "#c6d0df !important",
      borderBottomStyle: "solid !important",
      borderBottomWidth: "1px !important",
    },
    "& > .e-rte-content": {
      borderBottomRightRadius: "0.1875rem",
      borderBottomLeftRadius: "0.1875rem",
    },
    "& .e-toolbar-wrapper": {
      "& .e-toolbar": {
        borderRadius: "3px !important",
        "& .e-expended-nav": {
          borderTopRightRadius: "3px !important",
        },
      },
      "& .e-toolbar, & .e-extended-toolbar .e-toolbar-pop": {
        background: toolbarBgColor ? toolbarBgColor : `var(--button-light)`,
        "& .e-toolbar-items": {
          background: "var(--transparent)",
          "& .e-icons": {
            color: `${iconColor ? iconColor : "var(--disabled-text-gray)"} !important`,
          },
          "& .e-toolbar-popup": {
            background: "var(--transparent)",
          },
          "& .e-rte-dropdown-btn": {
            "& .e-rte-dropdown-btn-text": {
              color: `${iconColor ? iconColor : "var(--primary-text) "} !important`,
            },
          },
          "& .e-toolbar-item.e-active": {
            "& .e-tbar-btn": {
              background: "var(--transparent)",
              "& .e-icons": {
                background: ` ${
                  iconSelectedGradientColor1 && iconSelectedGradientColor2
                    ? `linear-gradient(100.44deg, ${iconSelectedGradientColor1} 0%, ${iconSelectedGradientColor2} 110.4%)`
                    : "linear-gradient(100.44deg, var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)"
                } `,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "var(--transparent)",
              },
            },
          },
        },

        "& .e-overlay": {
          background: "var(--transparent)",
          "& .e-icons": {
            color: "var(--light-black) !important",
            opacity: "0.5",
          },
          "& .e-toolbar-item.e-active": {
            "& .e-tbar-btn": {
              background: "var(--transparent)",
              "& .e-icons": {
                background: ` ${
                  iconSelectedGradientColor1 && iconSelectedGradientColor2
                    ? `linear-gradient(100.44deg, ${iconSelectedGradientColor1} 0%, ${iconSelectedGradientColor2} 110.4%)`
                    : "linear-gradient(100.44deg, var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)"
                } `,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "var(--transparent)",
              },
            },
          },
        },
        "& .e-toolbar-popup": {
          "& .e-icons": {
            color: `${iconColor ? iconColor : "var(--disabled-text-gray)"} !important`,
          },
        },
        "& .e-tbar-btn": {
          background: "var(--transparent)",
          minHeight: "24px !important",
          minWidth: "24px !important",
          borderRadius: "4px !important",
          "& span": {
            fontSize: "12px !important",
          },
          "&:hover": {
            background: iconHoverBgColor ? iconHoverBgColor : "var(--surface-white)",
            "& .e-icons": {
              color: `${iconHoverColor ? iconHoverColor : "var(--primary-text)"} !important`,
            },
          },
        },
      },
    },
  };
};

export const getSizeClass = (size: string) => {
  switch (size) {
    case "XXS":
      return "e-avatar-xxsmall";
    case "LSM":
      return "e-avatar-little-small";
    case "XS":
      return "e-avatar-xsmall";
    case "SM":
      return "e-avatar-small";
    case "LG":
      return "e-avatar-large";
    case "LLG":
      return "e-avatar-little-large";
    case "XL":
      return "e-avatar-xlarge";
    default:
      "e-avatar-small";
  }
};

export const getDropdownCommonCss = () => {
  return {
    background: "var(--surface-white) !important",
    color: "var(--primary-text) !important",
  };
};

export const getAvatarStyle = (bgColor: string) => {
  return {
    "& img": {
      height: "106%",
    },
    "&.e-avatar-square-organization": {
      boxShadow: "0 0 2px 0.5px var(--box-shadow)",
    },
    "& span": {
      fontWeight: "var(--font-weight-600)",
    },
    "&.e-avatar-xxsmall": {
      width: "1.25rem",
      height: "1.25rem",
      "& span": {
        fontSize: "0.5625rem",
      },
    },
    "&.e-avatar-xsmall": {
      width: "1.5rem",
      height: "1.5rem",
      "&.e-avatar-square-portal": {
        borderRadius: "0.25rem",
      },
      "&.e-avatar-square-organization": {
        borderRadius: "0.1875rem",
      },
      "& span": {
        fontSize: "0.75rem",
      },
    },
    "&.e-avatar-little-small": {
      width: "1.875rem",
      height: "1.875rem",
      "& span": {
        fontSize: "1rem",
      },
    },
    "&.e-avatar-small": {
      width: "2.25rem",
      height: "2.25rem",
      "&.e-avatar-square-portal": {
        borderRadius: "0.375rem",
      },
      "&.e-avatar-square-organization": {
        borderRadius: "0.0625rem",
      },
      "& span": {
        fontSize: "1.25rem",
      },
    },
    "&.e-avatar-large": {
      width: "3rem",
      height: "3rem",
      "&.e-avatar-square-portal": {
        borderRadius: "0.5rem",
      },
      "&.e-avatar-square-organization": {
        borderRadius: "0.125rem",
      },
      "& span": {
        fontSize: "1.625rem",
      },
    },
    "&.e-avatar-little-large": {
      width: "4.6875rem",
      height: "4.6875rem",
      "&.e-avatar-square-portal": {
        borderRadius: "0.75rem",
      },
      "&.e-avatar-square-organization": {
        borderRadius: "0.1875rem",
      },
      "& span": {
        fontSize: "2rem",
      },
    },
    "&.e-avatar-xlarge": {
      width: "6.25rem",
      height: "6.25rem",
      "&.e-avatar-square-portal": {
        borderRadius: "1rem",
      },
      "&.e-avatar-square-organization": {
        borderRadius: "0.375rem",
      },
      "& span": {
        fontSize: "3.5rem",
      },
    },
    backgroundColor: `${bgColor ? bgColor : "var(system-colour-9)"} !important`,
    "&.e-avatar": {
      fontFamily: "Source Sans 3 !important",
    },
  };
};

export const getAvatarGroupStyle = () => {
  return {
    display: "var(--display-flex)",
    gap: "0.1875rem",
    justifyContent: "flex-start",
    "& .e-avatar:not(:first-child)": {
      marginInlineStart: "-12px",
    },
  };
};

export const tableStyle = (background: string) => {
  return {
    "& .e-headercontent": {
      "& .e-columnheader": {
        "& .e-headercell": {
          background: background,
          borderBottom: "1px solid #ecf3fe !important",
          paddingInlineStart: "1.375rem",
        },
      },
    },
    "& .e-content": {
      overflow: "hidden !important",
    },
    "& .e-gridheader": {
      border: "none !important",
    },
    "& .e-headercelldiv": {
      color: "var(--primary-text) !important",
      fontSize: "0.875rem",
      fontWeight: "600",
    },
    "& .e-rowcell": {
      fontSize: "0.75rem",
      borderColor: "#ecf3fe",
      paddingInlineStart: "23px !important",
    },
  };
};

export const getCardStyle = (width: any, background: any, textColor: any) => {
  return {
    width,
    background: "linear-gradient(111deg, var(--surface-white) 45%, var(--white-opacity) 129%)",
    boxShadow: "4px 4px 15px 0 var(--card-box-shadow)",
    borderRadius: "0.5rem",
    backgroundImage: "linear-gradient(132deg, #fff, rgba(255, 255, 255, 0.5) 100%)",
    "& > .e-card-header": {
      background: "rgba(209, 223, 244, 0.5)",
      padding: "0 !important",
      width: "100% !important",
      "& .e-card-header-content-wrapper": {
        display: "var(--display-flex)",
        justifyContent: "var(--justify-space-between)",
        padding: "11px 20px 11px 20px",
        "& .e-card-header-title": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontStyle: "var(--font-style-normal)",
          fontWeight: "var(--font-weight-bold)",
          fontSize: "0.875rem",
          lineHeight: "1.125rem",
          color: textColor,
          "& .e-card-header-sub-title": {
            color: "var(--soft-gray)",
          },
        },
        "& .e-card-header-link": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontStyle: "var(--font-style-normal)",
          fontWeight: "var(--font-weight-700)",
          fontSize: "0.875rem",
          lineHeight: "1.125rem",
          background: `linear-gradient(100.44deg, var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "var(--transparent)",
          backgroundClip: "text",
          paddingInlineEnd: "0.625rem",
        },
        "& .e-card-header-share": {
          marginInlineStart: "1rem",
          display: "flex",
          alignSelf: "end",
        },
        "& .e-card-header-max": {
          marginInlineEnd: "1.125rem",
        },
        "& .e-card-header-ellipcise": {
          padding: "0",
          background: "white",
          border: "none",
          display: "flex",
        },
      },
    },
    "&.e-card, &.e-card:hover": {
      border: "var(--none) !important",
      padding: "0",
      flexBasis: "19.375rem",
      flexShrink: "1",
    },

    "& > .e-card-content": {
      display: "flex",
      padding: "0",
      height: "100%",
      alignItems: "flex-start",
      background: background,
      color: textColor,
      overflow: "auto",
    },
  };
};

export const getFeedbackToastStyle = (title: string) => {
  return {
    zIndex: "999999999 !important",
    background: "var(--surface-white) !important",
    border: "1.11111px var(--border-solid) var(--surface-neutral) !important",
    boxShadow: "0px 0px 17.7778px 2.22222px var(--box-shadow) !important",
    borderRadius: "6px !important",
    alignItems: "var(--align-center)",
    marginBottom: "3.125rem",
    marginInlineEnd: "2.5rem",
    "&.e-toast-container .e-toast": {
      margin: "0 !important",
      padding: "34px !important",
    },
    "& .e-toast-message": {
      display: "var(--display-grid) !important",
      gridTemplateAreas: title ? "'heading button' 'subheading button'" : "'subheading button'",
      alignItems: "var(--align-center)",
      "& .e-toast-title": {
        gridArea: "heading",
      },
      "& .e-toast-content": {
        gridArea: "subheading",
        padding: "0 15px 0 0 !important",
        "& .toastContent": {
          display: "var(--display-flex)",
          alignItems: "var(--align-center)",
        },
      },
      "& .e-toast-actions": {
        gridArea: "button",
        padding: "0 15px 0 0 !important",
        "& button": {
          whiteSpace: "nowrap !important",
          background: "var(--transparent) !important",
          border: "var(--none) !important",
          boxShadow: "var(--none) !important",
          color: "var(--text-light) !important",
          fontFamily: "Source Sans 3 !important",
          fontStyle: "var(--font-style-normal) !important",
          fontWeight: "var(--font-weight-600) !important",
          fontSize: "14px !important",
          marginInlineStart: "30px !important",
          padding: "6px !important",
        },
      },
    },
    "&.e-toast": {
      "& .e-icons": {
        fontSize: "0.6875rem",
        color: "var(--primary-text) !important",
        "&.e-toast-icon": {
          "&:before": {
            width: "30px !important",
            height: "30px !important",
            backgroundSize: "1.5rem",
            backgroundPosition: "var(--bg-position-center) var(--bg-position-center)",
            backgroundRepeat: "var(--background-no-repeat)",
            content: "''",
          },
          "&.e-toast-error-icon:before": {
            backgroundImage: "url('/assets/icons/svg/toastError.svg')",
          },
          "&.e-toast-info-icon:before": {
            backgroundImage: "url('/assets/icons/svg/toastInfo.svg')",
          },
          "&.e-toast-warning-icon:before": {
            backgroundImage: "url('/assets/icons/svg/toastWarning.svg')",
          },
          "&.e-toast-success-icon:before": {
            backgroundImage: "url('/assets/icons/svg/toastSuccess.svg')",
          },
        },
      },
    },
    "&.e-toast-success": {
      "& > .e-toast-progress": {
        background: "var(--positive-communication) !important",
      },
    },
    "&.e-toast-warning": {
      "& > .e-toast-progress": {
        background: "var(--warning) !important",
      },
    },
    "&.e-toast-info": {
      "& > .e-toast-progress": {
        background: "var(--primary-gradient-color2) !important",
      },
    },
    "&.e-toast-error": {
      "& .e-toast-progress": {
        background: "var(--negative-communication) !important",
      },
    },
    "& > .e-toast-progress": {
      height: "8px !important",
      borderRadius: "0.3125rem",
    },
  };
};

export const getDialogModalStyle = (headerBgColor: string) => {
  return {
    background: "linear-gradient(135deg, var(--surface-white) 44.5%, var(--light-gray) 129%)",
    boxShadow: "4px 8px 8px rgba(0, 0, 0, 0.15)",
    borderRadius: "0.375rem",
    outline: "var(--none)",
    overflow: "auto",
    "& > :nth-child(1)": {
      background: headerBgColor,
    },
    "& .e-dlg-header-content": {
      padding: "40px 40px 15px 40px",
      "& .e-dlg-header": {
        width: "100% !important",
      },
      "& .e-dlg-header *": {
        fontFamily: "Source Sans 3",
        fontStyle: "var(--font-style-normal)",
        fontWeight: "var(--font-weight-600) !important",
        fontSize: "24px !important",
        lineHeight: "30px !important",
        color: "var(--primary-text) !important",
      },
    },
    "& .e-dlg-content": {
      padding: "0 40px 40px 40px",
      "& .textComponentWrap": {
        paddingBottom: " 40px",
        "& ~ .formComponentWrap": {
          paddingTop: "0",
        },
      },
      "& .formComponentWrap": {
        paddingTop: "1.5625rem",
      },
      "& .dialogTextContent": {
        fontFamily: "Source Sans 3",
        fontStyle: "var(--font-style-normal)",
        fontWeight: "var(--font-weight-400) !important",
        fontSize: "14px !important",
        lineHeight: "18px !important",
        color: "var(--primary-text) !important",
      },
    },
    "& .e-footer-content": {
      padding: "0 40px 40px 40px !important",
    },
  };
};

export const getDialogHeaderStyle = () => {
  return {
    display: "var(--display-flex)",
    justifyContent: "var(--justify-space-between)",
    width: "100%",
  };
};

export const getTooltipStyle = (
  bgColor: string,
  fontSize: string,
  color: string,
  tipColor: string,
  maxHeight: string,
) => {
  return {
    background: `${bgColor ? bgColor : "var(--primary-text)"} !important`,
    border: "var(--none) !important",
    "& .e-tip-content": {
      fontFamily: "Source Sans 3 !important",
      fontStyle: "var(--font-style-normal)",
      fontWeight: "var(--font-weight-400)",
      fontSize: `${fontSize ? fontSize : "14px !important"}`,
      color: `${color ? color : "var(--surface-white) !important"}`,
      width: "auto !important",
      height: "100%",
      lineHeight: "22px !important",
      paddingTop: "8px !important",
      paddingBottom: "8px !important",
      paddingInlineStart: "16px !important",
      paddingInlineEnd: "16px !important",
      maxHeight: maxHeight,
    },
    "& .e-arrow-tip": {
      "& .e-arrow-tip-inner:before": {
        content: '""',
      },
      "& > .e-arrow-tip-outer, & > .e-arrow-tip-inner": {
        "&.e-tip-top": {
          borderBottom: `8px var(--border-solid) ${tipColor ? tipColor : "var(--primary-text) !important"}`,
          color: `${tipColor ? tipColor : "var(--primary-text) !important"}`,
        },
        "&.e-tip-bottom": {
          borderTop: `8px var(--border-solid) ${tipColor ? tipColor : "var(--primary-text) !important"}`,
          color: `${tipColor ? tipColor : "var(--primary-text) !important"}`,
        },
        "&.e-tip-right": {
          borderInlineStart: `8px var(--border-solid) ${tipColor ? tipColor : "var(--primary-text) !important"}`,
          color: `${tipColor ? tipColor : "var(--primary-text) !important"}`,
        },
        "&.e-tip-left": {
          borderInlineEnd: `8px var(--border-solid) ${tipColor ? tipColor : "var(--primary-text) !important"}`,
          color: `${tipColor ? tipColor : "var(--primary-text) !important"}`,
        },
      },
    },
  };
};

export const dropDownCommon = () => {
  return {
    paddingInlineStart: "0.625rem",
    paddingInlineEnd: "13px !important",
    "&.e-popup-open": {
      paddingInlineStart: "0 !important",
    },
  };
};
export const getDropDownGradientButtonStyle = () => {
  return {
    ...dropDownCommon(),
    background: `linear-gradient(100.44deg,  var(--primary-gradient-color1) 0%, var(--primary-gradient-color2) 110.4%) !important`,
    color: `var(--surface-white) !important`,
    "&.e-dropdown-popup.e-popup.e-control": getDropdownCommonCss(),
    borderRadius: "0.125rem",
    "&:hover,&:focus,&.e-active": {
      color: `var(--surface-white)`,
    },
    "&:disabled": {
      background: `var(--button-light) !important`,
      color: `var(--disabled-text-gray) !important`,
      cursor: "not-allowed !important",
    },

    "& .e-caret": {
      marginInlineStart: "0.625rem",
      "&:before, .e-dropdown-btn.e-btn .e-caret::before": {
        fontSize: "0.8125rem",
        display: "flex",
        justifyContent: "flex-end",
        // marginTop: '4px',
      },
    },
  };
};

export const getDropDownBackgroundButtonStyle = (args: any) => {
  return {
    ...dropDownCommon(),
    width: args.width ?? "",
    background: `var(--button-light)`,
    color: `var(--primary-text)`,
    "&.e-dropdown-popup ul": {
      width: args.popUpWidth ?? "",
      "& li": {
        alignItems: "center",
      },
    },
    "&.e-dropdown-popup.e-popup.e-control": getDropdownCommonCss(),
    borderRadius: "0.3125rem",
    "&:hover": {
      background: `var(--button-light)`,
      color: `var(--primary-text)`,
    },
    "&:focus": {
      background: `var(--button-light)`,
      color: `var(--primary-text)`,
      outline: "none",
    },
    "&:disabled": {
      background: `var(--button-light) !important`,
      color: `var(--disabled-text-gray) !important`,
      cursor: "not-allowed !important",
    },
    "& .e-caret": {
      marginInlineStart: "0.625rem",
    },
  };
};

export const getDropDownCustomButtonStyle = (args: any) => {
  return {
    ...dropDownCommon(),
    paddingInlineEnd: "0 !important",
    "&.e-dropdown-popup.e-popup.e-control": getDropdownCommonCss(),
    background: `transparent !important`,
    "&.e-dropdown-popup ul": {
      width: args.popUpWidth ?? "",
      maxHeight: args.maxPopUpHeight != null ? `${args.maxPopUpHeight} !important` : "",
      overflow: "auto",
      fontSize: "10px !important",
      "& li": {
        alignItems: "center",
      },
    },
    "&.e-dropdown-btn.e-lib.e-btn": {
      padding: "2px 13px 2px 13px !important",
    },
    "& .e-icons.e-icon-right.e-caret": {
      marginInlineStart: "0.625rem",
      marginTop: 0,
    },
    "&.e-dropdown-popup": {
      background: "var(--surface-white) !important",
    },
    "& .e-caret": {
      display: args.hideIcon ? "none" : "",
    },
  };
};

export const getSliderParentWrapperStyle = () => {
  return {
    "& .e-slider-hover .e-slider-track": {
      background: "var(--soft-gray) !important",
    },
    "& .e-control-wrapper.e-slider-container.e-horizontal": {
      display: "flex",
    },
  };
};

export const getSliderStyle = (
  gradientColor1: string,
  gradientColor2: string,
  color: string,
  handleShadowColor: string,
  handleGradientColor1: string,
  handleGradientColor2: string,
) => {
  return {
    "&.e-slider": {
      "& .e-range": {
        background:
          gradientColor1 && gradientColor2
            ? `linear-gradient(100.44deg, ${gradientColor1}  0%, ${gradientColor2} 110.4%) !important`
            : color,
      },
      "& .e-handle": {
        border: "var(--none) !important",
        boxShadow: handleShadowColor
          ? `${handleShadowColor}45 0 0 0 4px`
          : "var(--primary-gradient-color2-opacity) 0 0 0 4px",
        transition: "transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) 0s",
        background: `linear-gradient(100.44deg, ${handleGradientColor1}  0%, ${handleGradientColor2} 110.4%) !important`,
      },
      "& .e-slider-track": {
        borderRadius: "0.625rem",
        "&:hover": {
          background: "var(--soft-gray) !important",
        },
      },
    },
  };
};

export const getLocationList = (locations: any) => {
  const parseLocation = JSON.parse(locations);
  return parseLocation.map((s: any, index: any) => {
    return {
      id: Date.now() + index,
      name: s.name,
      formName: "location" + (index + 1),
      errorMsz: "",
    };
  });
};

export const getProfileCropControls = () => {
  return {
    marginTop: "1.875rem",
    marginBottom: "1.875rem",
    display: "var(--display-flex)",
    alignItems: "center",
    justifyContent: "space-around",
    "& label": {
      marginInlineEnd: "0.9375rem",
      fontFamily: "Source Sans 3 !important",
      fontSize: "0.875rem",
      fontWeight: "var(--font-weight-600)",
      fontStyle: "var(--font-style-normal)",

      color: "var(--primary-text)",
    },
    '& .sliderWrapper [class*="parentWrapper"]': {
      display: "var(--display-flex)",
      alignItems: "center",
    },
  };
};

export const getCanvasToFile = (image: any, cropProfilePic: any, cropRotate: any, cropScale: any) => {
  if (image) {
    const TO_RADIANS = Math.PI / 180;

    const documentDOM: any = document as any;
    const canvas: any = documentDOM.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      throw new Error("No 2d context");
    }

    const scaleX = image?.naturalWidth / image?.width;
    const scaleY = image?.naturalHeight / image?.height;
    // devicePixelRatio slightly increases sharpness on retina devices
    // at the expense of slightly slower render times and needing to
    // size the image back down if you want to download/upload and be
    // true to the images natural size.
    const pixelRatio = window.devicePixelRatio;
    // const pixelRatio = 1
    let width: any;
    let height: any;
    let xAxis: any;
    let yAxis: any;

    if (cropProfilePic.unit === "px") {
      width = cropProfilePic.width;
      height = cropProfilePic.height;
      xAxis = cropProfilePic.x;
      yAxis = cropProfilePic.y;
    }
    if (cropProfilePic.unit === "%") {
      width = (image?.width / 100) * cropProfilePic.width;
      height = (image?.height / 100) * cropProfilePic.height;
      xAxis = (image?.width / 100) * cropProfilePic.x;
      yAxis = (image?.height / 100) * cropProfilePic.y;
    }
    canvas.width = Math.floor(width * scaleX * pixelRatio);
    canvas.height = Math.floor(height * scaleY * pixelRatio);

    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";

    const cropX = xAxis * scaleX;
    const cropY = yAxis * scaleY;

    const rotateRads = cropRotate * TO_RADIANS;
    const centerX = image?.naturalWidth / 2;
    const centerY = image?.naturalHeight / 2;

    ctx.save();

    ctx.translate(-cropX, -cropY);
    ctx.translate(centerX, centerY);
    ctx.rotate(rotateRads);
    ctx.scale(cropScale, cropScale);
    ctx.translate(-centerX, -centerY);
    ctx.drawImage(
      image,
      0,
      0,
      image?.naturalWidth,
      image?.naturalHeight,
      0,
      0,
      image?.naturalWidth,
      image?.naturalHeight,
    );

    return canvas;
  } else {
    return null;
  }
};

export const getCroppedImgInBase64 = (image: any, cropProfilePic: any, cropRotate: any, cropScale: any) => {
  const canvas = getCanvasToFile(image, cropProfilePic, cropRotate, cropScale);
  // As Base64 string
  const base64Image: any = canvas?.toDataURL("image/jpeg");
  // // As a blob
  const blob = new Promise((resolve) => {
    canvas.toBlob((file: any) => {
      file.name = "profile.jpeg";
      resolve(file);
    }, "image/jpeg");
  });

  return { base64Image, blob };
};

export const getCroppedImgInBlob = (image: any, cropProfilePic: any, cropRotate: any, cropScale: any) => {
  const canvas = getCanvasToFile(image, cropProfilePic, cropRotate, cropScale);

  if (canvas) {
    // // As a blob
    return canvas.toBlob((file: any) => {
      file.name = "profile.jpeg";
    }, "image/jpeg");
  }
};

export const getDropdownListCssClass = (type: string, classes: any) => {
  if (type) {
    return `${classes[type]}`;
  }
  return classes.dropdownBackgroundList;
};

export const getSignStatusInitialUserInformation = (
  fileVersionId: string,
  resourceType: string,
  userDetails: any,
  projectData: any,
) => {
  return {
    name: `${userDetails?.firstName} ${userDetails?.lastName}`,
    userId: userDetails?.id,
    projectId: projectData?.id,
    signType: SignTypeValues.ATTACH_SIGNED_DOCUMENT,
    signDoc: "",
    comment: "",
    fileVersionId: fileVersionId,
    resourceType: resourceType,
    prevStatus: "",
    status: "",
    error: {
      signDoc: "",
      comment: "",
      status: "",
    },
  };
};

export const getFormattedFileStatus = (statusName: string) => {
  return statusName?.charAt(0).toUpperCase() + statusName?.substring(1).toLocaleLowerCase().replace(/_/g, " ");
};

export const getNameInitials = (userData: any) => {
  let initial = userData?.firstName && userData?.firstName?.[0]?.toUpperCase();
  if (userData.lastName && userData.lastName?.length > 0) {
    initial += userData?.lastName?.[0]?.toUpperCase();
  }
  return initial;
};

export const getDropDownStyle = (width: string) => {
  return {
    "& .dropdown-content": {
      width: width,
      borderRadius: "0.125rem",
      boxShadow: "2px 2px 4px 0 rgba(25, 32, 72, 0.15)",
      border: "solid 1px #ecf3fe",
      background: "#fff",
      position: "fixed",
      marginInlineStart: "-160px",
      marginTop: " 25px",
      zIndex: "99999",
      overflowX: "hidden",
      overflowY: "hidden",
    },
  };
};

export const getUrlForImage = (data: any, type = "profile") => {
  return `${getBackendUrl()}/fileSystemServer/getImage/${type}/${data.id}`;
};

export function isMergeAllowed(fileObjArray: any[]) {
  let fileSettings = {
    mergedAllowed: true,
    isFile: true,
  };

  let hasEstimate = false;
  let hasFile = false;

  for (let i = 0; i < fileObjArray.length; i++) {
    const fileObj = fileObjArray[i];

    if (fileObj.resourceType === "RESOURCE_TYPE_MERGED_FILE") {
      if (hasEstimate) {
        fileSettings.mergedAllowed = false;
        break;
      }
      hasFile = true;
    }

    if (fileObj.resourceType === "RESOURCE_TYPE_ESTIMATE") {
      fileSettings.isFile = false;
      hasEstimate = true;
    } else {
      if (!["CAD", "BIM"].includes(fileObj.engineType)) {
        fileSettings.mergedAllowed = false;
        break;
      }
      hasFile = true;
    }
  }

  if (hasEstimate && hasFile) {
    fileSettings.mergedAllowed = false;
  }

  return fileSettings;
}

export const conversionStatusTemplate = (params: { conversionStatus: string }) => {
  let name;
  let tooltip;

  if (params.conversionStatus == "NOT_STARTED" || params.conversionStatus == "RETRY") {
    name = "FileConversionStatusNotStarted";
    if (params.conversionStatus == "NOT_STARTED") {
      tooltip = t("Not Started");
    } else {
      tooltip = t("Retry");
    }
  } else if (params.conversionStatus == "IN_PROGRESS") {
    name = "FileConversionStatusInProgress";
    tooltip = t("In Progress");
  } else if (params.conversionStatus == "COMPLETED") {
    name = "FileConversionStatusSuccessfull";
    tooltip = t("Successful");
  } else if (params.conversionStatus == "ERRORED") {
    name = "FileConversionStatusUnsuccessfull";
    tooltip = t("Failed");
  } else if (params.conversionStatus == "NOT_REQUIRED") {
    name = "FileConversionStatusNotRequired";
    tooltip = t("Conversion Not Required");
  } else {
    return "";
  }
  return (
    <div style={{ width: "1rem" }}>
      <IconComponent name={name} position="bottom" toolTipContent={tooltip} />
    </div>
  );
};

const fileIcons: any = import.meta.glob("../../assets/icons/svg/File*.svg", {
  eager: true,
  import: "default",
});
const shortcutIcons: any = import.meta.glob("../../assets/icons/svg/filesShortcutIcons/Sfile*.svg", {
  eager: true,
  import: "default",
});

export const getFileIcon = (fileName: string = "", className: string = "", isShortCutFile: boolean = false) => {
  const fileExtension = fileName?.split(".").pop()?.toUpperCase() ?? "";
  if (fileExtension) {
    const shortcutPath = `../../assets/icons/svg/filesShortcutIcons/Sfile${fileExtension}.svg`;
    const dynamicPath = `../../assets/icons/svg/File${fileExtension}.svg`;
    if (!isShortCutFile && fileIcons[dynamicPath]) {
      const iconName = `File${fileExtension}`;
      return <IconComponent className={className} name={iconName} />;
    }
    if (isShortCutFile && shortcutIcons[shortcutPath]) {
      const iconName = `filesShortcutIcons/Sfile${fileExtension}`;
      return <IconComponent className={className} name={iconName} />;
    }
  }
  return <IconComponent className={className} name="FileNONE" />;
};

export const getIconbasedOnResourceType = (file: any, className = "") => {
  if (!file) {
    return "";
  }
  const { resourceType, permission, name, isContainer, containerType } = file;

  if (resourceType === "RESOURCE_TYPE_FOLDER" || resourceType === "RESOURCE_TYPE_TRANSMITTAL") {
    const iconName =
      !permission.copy && !permission.download && !permission.read && !permission.upload && !permission.write
        ? "folderlock"
        : "folder";

    return <IconComponent className={className} name={iconName} />;
  }

  const resourceTypeMap: any = {
    RESOURCE_TYPE_SCHEDULE: "schedules",
    RESOURCE_TYPE_ISSUES: "issues",
    RESOURCE_TYPE_TASKS: "tasks",
    RESOURCE_TYPE_CONTRACT: "Contracts",
    RESOURCE_TYPE_EMBED: "embedUrl",
    RESOURCE_TYPE_ESTIMATE: "EstimateIcon",
    RESOURCE_TYPE_MERGED_FILE: "FileMER",
  };

  if (resourceTypeMap[resourceType]) {
    return <IconComponent className={className} name={resourceTypeMap[resourceType]} />;
  }
  if (resourceType === "RESOURCE_TYPE_SHORTCUT_MERGED_FILE" || resourceType === "RESOURCE_TYPE_SHORTCUT_FILE") {
    return getFileIcon(name, className, true);
  }
  if (resourceType === "RESOURCE_TYPE_FILE") {
    if (isContainer && containerType) {
      return <IconComponent className={className} name={`File${containerType.toUpperCase()}`} />;
    }
    return getFileIcon(name, className);
  }
  return <IconComponent className={className} name="FileNONE" />;
};
